import { environment } from '../../../environments/environment';
import { FILTER_NAME, searchApplication } from '../helpers/app-context-helper';
import { BaseService } from '../base-service';

export abstract class BaseApiService extends BaseService {
  constructor(protected applicationName: string) {
    super();
  }

  public get baseApiUrl() {
    return environment.configurators2d.baseApi;
  }

  public get apiUrl() {
    return this.baseApiUrl + this.getAppProperty(app => app.apiName);
  }

  public imgPath(path: string, cut?: boolean) {
    let imgPath = path;
    if (cut) {
      let splitPath = path.split('.');
      let ext = splitPath.slice(-1)[0];
      imgPath = splitPath.slice(0, -1).join('.') + '_cut.' + ext;
    }
    return this.apiUrl + imgPath;
  }

  public get routeUrl() {
    return this.getAppProperty(app => app.routeUrl);
  }

  public get distribId() {
    return this.getAppProperty(app => app.distribID);
  }

  private getAppProperty(getProperty: (app: any) => string): string {
    if (this.applicationName === undefined) {
      return '';
    }
    let app = searchApplication(this.applicationName, FILTER_NAME.DISTRIB_ID);
    if (app === undefined) {
      app = environment.configurators2d.global[this.applicationName];
    }

    if (this.applicationName === 'kitchen') {
      return 'kitchen/';
    }
    if (this.applicationName === 'storage') {
      return 'storage/';
    }
    if (this.applicationName === 'bathroomV2') {
      return 'bathroom/';
    }
    if (this.applicationName === 'bathroom') {
      return 'bathroomHbm/';
    }

    if (app === undefined) {
      return '';
    }

    return getProperty(app);
  }
}
